import { FC } from 'react';
import { BackdropProps } from './backdrop.props';
import { Wrapper } from './backdrop.styled';

export const Backdrop: FC<BackdropProps> = ({ hide }) => {
    return <Wrapper onClick={hide}></Wrapper>;
};
